import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.string(),
  VITE_RECAPTCHA_V2_SITE_KEY: z.string(),
  VITE_RECAPTCHA_V3_SITE_KEY: z.string(),
  VITE_FUSIONAUTH_AUTHORITY: z.string(),
  VITE_FUSIONAUTH_GEARBELT_CLIENT_ID: z.string(),
  VITE_FORMS_URL: z.string(),
  VITE_GLOBAL_API_URL: z.string(),
  VITE_GOOGLE_MAPS_API_KEY: z.string(),
  VITE_DASHPIVOT_API_URL: z.string(),
  VITE_BUGSNAG_API_KEY: z.string(),
  VITE_BUGSNAG_RELEASE_STAGE: z.string(),
  VITE_GBMW_URL: z.string().optional(),
});

export { envSchema };
